<template>
    <div id="test-order-container">
        <b-row>
            <b-col class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="PatientTitle"
                    v-bind:titlePrefix="mode ? $t('TestOrder.EditTitle') : $t('TestOrder.AddTitle')"
                    v-bind:titleRef="'titleElementTestOrderList'"
                    v-bind:patientCode="this.$route.params.id"
                >
                </MdTitleRegInfo>

                <div
                    class="alert alert-fill-warning d-flex align-items-center m-3"
                    role="alert"
                    v-if="isReadOnly"
                >
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                    </div>
                </div>
            </b-col>
        </b-row>

        <MdTitle
            v-bind:VisibleInfo="false"
            v-bind:Text="createdBy"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Prescriber')"
                    v-bind:Options="prescriberList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:AllowEmpty="false"
                    v-bind:Model="modelPrescriber"
                    v-bind:Multiple="false"
                    v-bind:isRequired="true"
                    v-bind:isValid="isPrescriberValid"
                    :Input="changeDropDownPrescriber"
                    v-bind:FeedBackText="$t('Insurance.InsuranceTypeRequired')"
                    :IsDisabled="!isEditable"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('TestOrder.Type')"
                    v-bind:Options="orderTypes"
                    v-bind:Model="editableItem.orderType"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownOrderType"
                    :IsDisabled="!isEditable"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('MdNote.Sign')"
                    v-bind:Name="'checkboxAdd-Sign'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.isSigned"
                    v-on:change="onSignature"
                    v-bind:Tag="'SignMedication'"
                    :isReadOnly="!isEditable || mode"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:VisibleInfo="false"
            v-bind:Text="$t('TestOrder.Collection')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.DateAndTime')"
                    :Model="collectionDateTime"
                    @input="collectionDateTime = $event"
                    :Id="'TestOrderDateTime'"
                    :Type="'datetime'"
                    :isRequired="true"
                    :isConfirm="false"
                    :ReadOnly="!isEditable"
                    :isValid="isDateTimeValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Priority')"
                    v-bind:Options="priorities"
                    v-bind:Model="editableItem.priority"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownPriority"
                    :IsDisabled="!isEditable"
                />
            </b-col>
            <b-col lg="6" md="6" sm="12">
                <MdSelect
                    v-bind:Label="$t('TestOrder.Specimen')"
                    v-bind:Options="specimens"
                    v-bind:Model="editableItem.testSpecimen"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownSpecimen"
                    :IsDisabled="!isEditable"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Location')"
                    v-bind:Options="testOrderLocations"
                    v-bind:Model="editableItem.location"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownLocation"
                    :IsDisabled="!isEditable"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$tc('TestOrder.Fasting')"
                    v-bind:Name="'text'"
                    v-bind:TypeProp="'text'"
                    v-model="editableItem.fasting"
                    v-bind:isReadOnly="!isEditable"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <MdTitle
            v-bind:VisibleInfo="false"
            v-bind:Text="$t('TestOrder.SelectedTests')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col :lg="isEditable && !mode ? 10 : 12" :md="isEditable && !mode ? 10 : 12" sm="12">
                <MdCheckListBox2
                    v-model="editableItem.test"
                    v-bind:Options="testList"
                    v-bind:Height="'150px'"
                    v-bind:columnCount="2"
                    :textField="'name'"
                    :valueField="'code'"
                    :isReadOnly="!isEditable || mode"
                    :isRequired="true"
                    :isValid="isTestValid"
                >
                </MdCheckListBox2>
            </b-col>
            <b-col lg="2" md="2" sm="12" class="mt-3" v-if="isEditable && !mode">
                <MdButton
                    v-bind:Label="$t('TestOrder.AddTest')"
                    v-bind:Name="'btn_AddTest'"
                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                    v-on:click="addTest"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:VisibleInfo="false"
            v-bind:Text="$t('TestOrder.Instructions')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col lg="12" md="12" sm="12">
                <MdMemo
                    v-bind:Label="$t('TestOrder.Instructions')"
                    v-bind:VisibleLabel="false"
                    v-bind:isReadOnly="!isEditable"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'textarea_instructions'"
                    v-bind:Rows="'6'"
                    v-bind:MaxRows="'10'"
                    v-model="editableItem.comments"
                />
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBackToTestOrders'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="backToListing"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="!isEditable ? 'primary mx-2' : 'primary btn-login mx-2'"
                v-on:click="saveOrEdit"
                v-bind:isReadOnly="saveButtonDisabled"
                v-bind:Name="'btn_save_test_order'"
            />
        </div>

        <MdPasswordDlg
            v-if="showSignPassword"
            v-bind:Type="TypePassWord"
            v-bind:EmployeeCode="employeeSelected"
            @getModalPassword="onModalPasswordResult($event)"
        />

        <ModalTablePaginationServerMultiple
            v-bind:Resource="resourceParameter"
            v-bind:TypeOption="refCode"
            @getCodeConditionOK="onCodeConditionOk($event)"
            @getCodeConditionCancel="onCodeConditionCancel($event)"
            v-bind:Fields="fields"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'name'"
            v-bind:TitleWindow="$t('TestOrder.TestSelectDialog.Title')"
            v-bind:ModalId="modalId"
            v-bind:OptionParamList="paramList"
            v-bind:UseFilter="true"
            :FilterChange="changeFilter"
            v-bind:modelFilter="this.modelFilter"
        ></ModalTablePaginationServerMultiple>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import Permission from '@/common/Permission';
import StorageService from '@/services/storage.service';
import TestOrderLocationsService from '@/services/testorderlocations.service';
import MedicationService from '@/services/medication.service';
import PatientService from '@/services/patient.service';
import PharmacyOptions from '@/services/pharmacyoption.service';
import TestOrderResultsService from '@/services/testorderresults.service';
import TestOrdersService from '@/services/testorders.service';
import GlobalService from '@/services/global.service';
import { EventBus } from '@/event-bus.js';

export default {
    name: 'TestOrder',
    mixins: [ShowMessage, DBFunctions, Permission],
    data() {
        const testOrderAPI = 'PatientTestOrders/Panel?';
        return {
            OptionsRightMenu: {
                visible: true,
                ItemsList: [],
                btnvisible: true,
                itemdisabled: false,
                PatientCode: ''
            },
            RegistrationInfo: {},
            PatientInfo: {},
            currentAppointmentDB: {
                guid: '',
                activitytypecode: '',
                employee: {
                    firstname: '',
                    lastname: ''
                }
            },
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: '',
                activitytypename: '',
                startdatetime: '',
                ageFormatted: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            isReadOnly: false,
            pendingChanges: false,
            mode: this.$attrs.editMode,
            createdBy:
                this.$t('Shared.CreatedBy') +
                ': ' +
                Utils.strToTitleCase(StorageService.getName()) +
                '   ' +
                '<span class="highlightInTitle blueTitle">' +
                this.$t('Shared.New') +
                '</span>',
            editableItem: {
                prescriberCode: null,
                priority: null,
                testSpecimen: null,
                location: null,
                fasting: null,
                comments: null,
                orderType: null,
                isSigned: false,
                panelCode: null,
                test: [],
                recNo: this.$route.params.recNo
            },
            priorities: EnumService.TestOrderPriority,
            testOrderLocations: [],
            specimens: [],
            orderTypes: [],
            prescriberList: [],
            testList: [],
            showSignPassword: false,
            modelPrescriber: { code: '', name: '' },
            pharmacyOption: {},
            isPrescriberValid: true,
            isDateTimeValid: true,
            isTestValid: true,
            collectionDateTime: Utils.getCurrentDateTime(),
            modelFilter: {
                code: 1,
                description: this.$t('TestOrder.TestSelectDialog.TestPanels'),
                resource: testOrderAPI
            },
            paramList: [
                {
                    code: 1,
                    description: this.$t('TestOrder.TestSelectDialog.TestPanels'),
                    resource: testOrderAPI
                },
                {
                    code: 2,
                    description: this.$t('TestOrder.TestSelectDialog.TestsHistory'),
                    resource: 'PatientTestOrders/History?'
                },
                {
                    code: 3,
                    description: this.$t('TestOrder.TestSelectDialog.AllTests'),
                    resource: 'PatientTestResults/Setup?'
                }
            ],
            fields: [],
            modalId: Utils.generateUUID(),
            resourceParameter: '',
            testOrderAPI: testOrderAPI,
            refCode: 'testOrder',
            OffRoute: false,
            clickBack: false,
            wasSaved: false
        };
    },
    computed: {
        employeeSelected() {
            return StorageService.getUserId();
        },
        isEditable() {
            let isOrdered = true;

            if (this.mode) {
                isOrdered = this.editableItem.internalStatus === 'ORDERED';
            }

            return !this.isReadOnly && isOrdered;
        },
        saveButtonDisabled() {
            if (this.isReadOnly) {
                return true;
            }

            if (this.mode && this.editableItem.internalStatus !== 'ORDERED') {
                return true;
            }

            return !this.pendingChanges;
        }
    },
    methods: {
        backToListing() {
            this.clickBack = true;
            this.OffRoute = false;
            this.discardChanges();
        },

        discardChanges() {
            if (this.$route.name.includes('appointments-')) {
                this.$router.push({
                    name: 'appointments-test-orders',
                    params: {
                        id: this.$route.params.id,
                        actId: this.$route.params.actId
                    }
                });
            } else {
                this.$router.push({
                    name: 'clinical-test-orders',
                    params: { id: this.$route.params.id }
                });
            }
        },

        async clickOffRoute() {
            this.OffRoute = true;
            this.clickBack = false;
            await this.executeAction();
        },

        async saveOrEdit() {
            this.OffRoute = false;
            this.clickBack = false;
            await this.executeAction();
        },

        async executeAction() {
            if (this.isEditable && this.pendingChanges) {
                if (this.validateRequired()) {
                    if (this.mode) {
                        await this.updateTestOrder();
                    } else {
                        if (this.editableItem.isSigned) {
                            await this.addTestOrder();
                        } else {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                this.$t('MdPainAssessmentNotesOutCome.SingBeforeMsg'),
                                'errorAutoHide'
                            );
                        }
                    }
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.CheckRedLabeledFields'),
                        'errorAutoHide'
                    );
                }
            }
        },

        async updateTestOrder() {
            const dataToSave = this.prepareDataToSave();
            await TestOrdersService.update(this.editableItem.recNo, dataToSave)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        this.wasSaved = true;

                        if (!this.OffRoute || this.clickBack) {
                            this.discardChanges();
                        }

                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async addTestOrder() {
            const dataToSave = this.prepareDataToSave();
            await TestOrdersService.add(dataToSave)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        this.wasSaved = true;

                        if (!this.OffRoute || this.clickBack) {
                            this.discardChanges();
                        }

                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        validateRequired() {
            this.isPrescriberValid = Utils.isNullOrEmptyString(this.modelPrescriber.code)
                ? false
                : true;
            this.isDateTimeValid =
                this.collectionDateTime && Utils.isValidDate(this.collectionDateTime);
            this.isTestValid = this.editableItem.test.length !== 0;

            console.log(
                'validateRequired',
                this.collectionDateTime,
                Utils.isValidDate(this.collectionDateTime)
            );
            return this.isPrescriberValid && this.isDateTimeValid && this.isTestValid;
        },

        prepareDataToSave() {
            let data = {
                ...this.editableItem,
                patientCode: this.$route.params.id,
                admissionRecordId: this.$route.params.recordid,
                collectionDate: Utils.formatterToISO(Utils.toMidnight(this.collectionDateTime)),
                collectionTime: this.collectionDateTime,
                testOrders: this.testList
                    .filter(f => this.editableItem.test.includes(f.code))
                    .map(order => ({ orderCode: order.code, panelCode: order.panelCode }))
            };

            delete data.test;
            return data;
        },

        async getTestOrderAsync() {
            await TestOrdersService.get(this.editableItem.recNo)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.editableItem = response.data;
                        const upperCode = this.editableItem.prescriberCode?.toUpperCase();
                        const index = this.prescriberList.findIndex(
                            doctor => doctor.code && doctor.code.toUpperCase().trim() === upperCode
                        );

                        if (index !== -1) {
                            this.modelPrescriber.code = this.prescriberList[index].code;
                            this.modelPrescriber.name = this.prescriberList[index].name;
                        }

                        const data = {
                            code: this.editableItem.testCode.trim(),
                            name: this.editableItem.testName.trim(),
                            panelCode: this.editableItem.panelCode?.trim(),
                            panelName: this.editableItem.panelName?.trim()
                        };
                        this.editableItem.test = [data.code];
                        this.testList.push(data);
                        this.collectionDateTime = Utils.CombineDateAndTime(
                            this.editableItem.collectionDate,
                            this.editableItem.collectionTime
                        );

                        this.createdBy =
                            this.$t('Shared.CreatedBy') +
                            ': ' +
                            this.editableItem.employeeName +
                            ' ' +
                            Utils.formatterDateTimeToString(this.editableItem.sysDate) +
                            '   ' +
                            '<span class="highlightInTitle blueTitle">' +
                            this.$t(
                                'Medication.internalStatus.' + this.editableItem.internalStatus
                            ) +
                            '</span>';

                        console.log(
                            'getTestOrderAsync',
                            this.editableItem,
                            this.createdBy,
                            this.collectionDateTime
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        changeDropDownPriority(value) {
            this.editableItem.priority = value ? value.value : null;
        },

        changeDropDownLocation(value) {
            this.editableItem.location = value ? value.code : null;
        },

        changeDropDownSpecimen(value) {
            this.editableItem.testSpecimen = value ? value.value : null;
        },

        changeDropDownOrderType(value) {
            console.log('changeDropDownOrderType', value);
            this.editableItem.orderType = value ? value.code : null;
        },

        changeDropDownPrescriber(item) {
            if (item !== null) {
                this.modelPrescriber = item;
                this.editableItem.prescriberCode = item.code;
            } else {
                this.modelPrescriber = { code: '', name: '' };
                this.editableItem.prescriberCode = '';
            }
        },

        onModalPasswordResult(result) {
            if (result.type === 'Sign') {
                if (result.Event === 'Ok') {
                    if (result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'), result.message, 'error');
                        this.editableItem.isSigned = false;
                    }
                } else {
                    this.editableItem.isSigned = false;
                }
            }
            this.showSignPassword = false;
        },

        onSignature(value) {
            this.TypePassWord = 'Sign';
            this.showSignPassword = value;
        },

        onCodeConditionOk(result) {
            this.$bvModal.hide(this.modalId);
            this.resourceParameter = '';

            var type = result.FieldName;
            if (type.indexOf(this.refCode) !== -1 && result.code) {
                const data = {
                    code: result.code.trim(),
                    name: result.description.trim(),
                    panelCode: null,
                    panelName: null
                };

                if (this.modelFilter.code !== 1) {
                    const indexOf = this.testList.findIndex(test => test.code === data.code);

                    if (indexOf === -1) {
                        this.editableItem.test.push(data.code);
                        this.testList.push(data);
                        this.testList.sort((a, b) => {
                            const x = a.name.toLowerCase();
                            const y = b.name.toLowerCase();
                            return x < y ? -1 : x > y ? 1 : 0;
                        });
                    }
                } else {
                    this.addTestOrderFromPanelCode(data);
                }
            }
        },

        onCodeConditionCancel() {
            this.resourceParameter = '';
        },

        changeFilter(e) {
            this.resourceParameter = '/' + e.resource;
            this.modelFilter = e;
        },

        addTest() {
            this.resourceParameter = '/' + this.testOrderAPI;
            this.modelFilter = {
                code: 1,
                description: this.$t('TestOrder.TestSelectDialog.TestPanels'),
                resource: this.testOrderAPI
            };
            this.$bvModal.show(this.modalId);
        },

        addTestOrderFromPanelCode(panel) {
            TestOrderResultsService.getTestOrderFromPanelControl(panel.code)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        response.data.forEach(order => {
                            const data = {
                                code: order.code.trim(),
                                name: order.description.trim(),
                                panelCode: panel.code,
                                panelName: panel.name
                            };
                            const indexOf = this.testList.findIndex(
                                test => test.code === data.code
                            );

                            if (indexOf === -1) {
                                this.editableItem.test.push(data.code);
                                this.testList.push(data);
                            }
                        });

                        if (response.data.length !== 0) {
                            this.testList.sort((a, b) => {
                                const x = a.name.toLowerCase();
                                const y = b.name.toLowerCase();
                                return x < y ? -1 : x > y ? 1 : 0;
                            });
                        } else {
                            this.showMessage(
                                this.$t('Shared.TestOrders'),
                                this.$t('TestOrder.NotOrderFromPanel'),
                                'warning'
                            );
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename = this.currentAppointmentDB.activitytypename;
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(
                this.currentAppointmentDB.transdate
            )} ${this.currentAppointmentDB.timein}`;
        },

        PopulatePatientTitle() {
            if (this.$route.name.includes('clinical-')) {
                const {
                    dob,
                    dateFrom,
                    dateTo,
                    age,
                    programName,
                    patientName,
                    ageFormatted
                } = this.RegistrationInfo; // Destructure for easier access

                if (programName) this.PatientTitle.programName = programName;
                if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
                if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
                if (patientName) this.PatientTitle.fullName = patientName;
                if (dob) this.PatientTitle.dob = this.PatientInfo.dob;
                if (age) this.PatientTitle.age = age === 0 ? '0' : age;
                if (ageFormatted)
                    this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
            }
        },

        async GetPatientByCode() {
            var infoList = await this.getInfoTitle(this.$route.params.id);
            if (infoList.length > 0) {
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';

                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' ' + lastname;
            }
        },

        async registrationInfoTitleAsync() {
            this.RegistrationInfo = await this.getRegistrationInfoTitle(
                this.$route.params.recordid
            );
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);
            if (dob) this.RegistrationInfo.dob = Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? '0' : age;
        },

        async getTestOrderLocations() {
            await TestOrderLocationsService.getLookup()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.testOrderLocations = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getSpecimenSourceAsync() {
            await GlobalService.getSpecimenType()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.specimens = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getOrderTypeAsync() {
            await GlobalService.getOrderType()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.orderTypes = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getPrescribers() {
            await MedicationService.getPrescribers()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.prescriberList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getDefaultDoctor() {
            await PatientService.getDefaultDoctor(this.$route.params.id || this.PCode)
                .then(response => {
                    if (response.status == '200') {
                        const defaultDoctor = response.data;

                        if (this.prescriberExist(defaultDoctor.doctorCode)) {
                            this.modelPrescriber.code = defaultDoctor.doctorCode;
                            this.modelPrescriber.name = defaultDoctor.doctorName;
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getPharmacyOptions() {
            await PharmacyOptions.getPharmacyOptions()
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.pharmacyOption = response.data[0];
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async setDefaultDoctor() {
            if (this.pharmacyOption && this.pharmacyOption.usePatientDoctorAsPrescriber) {
                await this.getDefaultDoctor();
            } else {
                if (this.prescriberExist(this.$store.state.employeeCode)) {
                    this.modelPrescriber.code = this.$store.state.employeeCode;
                    this.modelPrescriber.name = Utils.strToTitleCase(StorageService.getName());
                }
            }
        },

        prescriberExist(code) {
            const upperCode = code.toUpperCase().trim();
            const index = this.prescriberList.findIndex(
                doctor => doctor.code && doctor.code.toUpperCase().trim() === upperCode
            );

            return index !== -1;
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        initializeBusEvent() {
            this.$nextTick(() =>
                EventBus.$on(
                    'onChanged',
                    function(e) {
                        this.pendingChanges |= e.Changed;
                    }.bind(this)
                )
            );
        }
    },

    async mounted() {
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('appointments-')
            ? EnumService.AppointmentItems
            : EnumService.ClinicalItems;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);
        this.isReadOnly = this.$store.state.isTestOrdersEHRReadOnly;

        const initialPromise = [
            this.getTestOrderLocations(),
            this.PopulatePatientTitle(),
            this.GetPatientByCode(),
            this.registrationInfoTitleAsync(),
            this.getSpecimenSourceAsync(),
            this.getPrescribers(),
            this.getPharmacyOptions(),
            this.getOrderTypeAsync()
        ];

        if (this.$route.name.includes('appointments-')) {
            //await this.getCurrentAppointment();
            initialPromise.push(this.getCurrentAppointment());
        }

        Promise.allSettled(initialPromise).then(() => {
            const anotherPromise = [];

            if (this.mode) {
                anotherPromise.push(this.getTestOrderAsync());
            } else {
                anotherPromise.push(this.setDefaultDoctor());
            }
            Promise.allSettled(anotherPromise).then(() => this.initializeBusEvent());
        });
    },

    created() {
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
        EventBus.$off('onChanged');
    },

    beforeRouteLeave(to, from, next) {
        if (this.isEditable && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('Shared.TestOrders'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.clickOffRoute();

                        if (this.wasSaved) {
                            next();
                        }
                    }
                });
        } else {
            next();
        }
    }
};
</script>
